import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "badge"]
  static values = {
    countSelector: String
  }
  static classes = ["active", "hidden"]

  connect() {
    if (this.hasBadgeTarget) {
      this.badgeTarget.setAttribute("aria-hidden", "true")
    }
    this.update()
  }

  update() {
    const count = document.querySelectorAll(this.countSelectorValue).length
    const buttonText = this.buttonTarget.textContent.trim().replace(/\d+$/, "").trim()
    
    if (count > 0) {
      if (this.hasBadgeTarget) {
        this.badgeTarget.textContent = count
        this.badgeTarget.classList.remove(this.hiddenClass)
      }
      this.buttonTarget.classList.add(this.activeClass)
      this.buttonTarget.setAttribute("aria-label", `${buttonText}, ${count} selected`)
    } else {
      if (this.hasBadgeTarget) {
        this.badgeTarget.classList.add(this.hiddenClass)
      }
      this.buttonTarget.classList.remove(this.activeClass)
      this.buttonTarget.setAttribute("aria-label", buttonText)
    }
  }
}
